// a reuseable plant bar meter
import React, { useMemo } from "react";

export default function PlantResourceMeter({
  label = "Water",
  value = 0,
  total = 5,
  icon = "",
  accentClass = "",
}) {
  const clamped = Math.max(0, Math.min(total, value));
  const pct = (clamped / total) * 100;
  const ticks = useMemo(
    () => Array.from({ length: total + 1 }, (_, i) => i),
    [total]
  );

  return (
    <div
      className={`plant-meter-row ${accentClass}`}
      aria-label={`${label} ${clamped} of ${total}`}
    >
      <div className="plant-meter-label-wrap">
        {icon ? <span className="plant-meter-icon">{icon}</span> : null}
        <span className="plant-meter-label">{label}</span>
      </div>

      <div className="plant-meter-bar">
        <div
          className="plant-meter-fill"
          style={{ width: `${pct}%` }}
        />
        {ticks.map((t) => (
          <span
            key={t}
            className="plant-meter-tick"
            style={{ left: `${(t / total) * 100}%` }}
          />
        ))}
      </div>

      <span className="plant-meter-value">
        {Math.round(clamped * 10) / 10}/{total}
      </span>
    </div>
  );
}